// extracted by mini-css-extract-plugin
module.exports = {"note":"note___3XBzt","isCentered":"isCentered___1BCOZ"};